/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum DepositType {
  absolute = 'absolute',
  percentage = 'percentage',
}

export enum FeatureType {
  multi = 'multi',
  mutex0 = 'mutex0',
  mutex1 = 'mutex1',
}

export enum FinanceFormType {
  cash = 'cash',
  finance = 'finance',
}

export enum FinanceResultType {
  cash = 'cash',
  error = 'error',
  finance = 'finance',
  na = 'na',
}

export enum JourneyType {
  continue_in_dealership = 'continue_in_dealership',
  reserve_online = 'reserve_online',
}

export enum LoanTermPeriodUnit {
  month = 'month',
}

export interface EnquiryFormData {
  formData?: string | null;
}

export interface FeatureIdsInput {
  values?: (string | null)[] | null;
  selected?: (string | null)[] | null;
  added?: (string | null)[] | null;
  removed?: (string | null)[] | null;
  included?: (string | null)[] | null;
}

export interface Filters {
  trimCode: any;
  bodyStyleCode?: string | null;
  variantCode?: string | null;
  modelCode?: string | null;
  engineCode?: string | null;
  specPackCode?: string | null;
}

export interface FinanceFormInput {
  paymentType: FinanceFormType;
  financeProductId?: string | null;
  financePackageId?: string | null;
  term?: number | null;
  deposit?: number | null;
  interestRate?: number | null;
  mileage?: number | null;
  partExchangeId?: string | null;
  ageRange?: string | null;
  homeOwner?: string | null;
}

export interface FinanceInput {
  journeyType: FinanceFormType;
  financeProductId?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
